if (!customElements.get('vessel-subscribe-popup')) {
  customElements.define('vessel-subscribe-popup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      if (!this.dialog || !this.form) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.storageKey = 'vesselNewsletterSubmission';
      this.triggerSelector = `[aria-controls="${this.dialog.id}"]`;
      this.titleElement = this.querySelector('.vsub-title');
      this.isSuccessful = false;
      const formAction = new URL(this.form.action, location.href);
      formAction.hash = this.form.id;
      this.form.action = formAction.href;

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest(this.triggerSelector);
        if (!trigger) return;
        event.preventDefault();
        this.open(trigger);
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target.closest('[data-vsub-close]')) {
          this.dialog.close();
          return;
        }
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.afterClose(), options);
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const focusable = [...this.dialog.querySelectorAll('a[href], button, input, [tabindex="0"]')].filter((element) => !element.disabled && element.getClientRects().length);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }, options);
      document.addEventListener('submit', (event) => {
        if (event.target === this.form) {
          try {
            sessionStorage.setItem(this.storageKey, JSON.stringify({ formId: this.form.id, at: Date.now() }));
          } catch (_) {}
        } else if (event.target.querySelector('input[name="form_type"][value="customer"]')) {
          this.clearSubmission();
        }
      }, { ...options, capture: true });
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) this.open();
      }, options);
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail.sectionId === this.dataset.sectionId && this.dialog.open) this.dialog.close();
      }, options);
      this.restoreResult();
    }

    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        this.afterClose();
      }
      this.controller?.abort();
    }

    open(trigger) {
      if (this.dialog.open) return;
      this.lastTrigger = trigger || document.querySelector(this.triggerSelector);
      this.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.dialog.showModal();
      const scrollContainer = this.querySelector('.vsub-layout');
      if (scrollContainer) scrollContainer.scrollTop = 0;
      this.updateTriggers(true);
      const focusTarget = this.isSuccessful ? this.querySelector('.vsub-success') : this.titleElement;
      focusTarget?.focus({ preventScroll: true });
    }

    afterClose() {
      if (this.previousOverflow !== undefined) {
        document.body.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
      this.updateTriggers(false);
      if (this.lastTrigger?.isConnected) this.lastTrigger.focus({ preventScroll: true });
    }

    updateTriggers(expanded) {
      document.querySelectorAll(this.triggerSelector).forEach((trigger) => trigger.setAttribute('aria-expanded', String(expanded)));
    }

    clearSubmission() {
      try { sessionStorage.removeItem(this.storageKey); } catch (_) {}
    }

    restoreResult() {
      const result = this.querySelector('[data-vsub-result]');
      if (!result) return;
      let ownSubmission = false;
      try {
        const pending = JSON.parse(sessionStorage.getItem(this.storageKey));
        const age = Date.now() - pending?.at;
        ownSubmission = pending?.formId === this.form.id && age >= 0 && age < 15 * 60 * 1000;
      } catch (_) {
        ownSubmission = location.hash === `#${this.form.id}`;
      }
      const succeeded = result.dataset.success === 'true';
      const failed = result.dataset.errors === 'true';
      if (!ownSubmission || (!succeeded && !failed)) return;
      this.clearSubmission();
      if (succeeded) {
        this.isSuccessful = true;
        this.titleElement.textContent = this.querySelector('[data-vsub-success-title]').content.textContent;
        this.querySelector('[data-vsub-entry]').hidden = true;
        this.querySelector('[data-vsub-success]').hidden = false;
        this.dialog.removeAttribute('aria-describedby');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'newsletter_signup',
          event_id: `lead-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`,
          content_name: 'Subscribe Popup',
          content_category: 'Newsletter',
          signup_source: 'announcement-bar',
          currency: this.dataset.currency,
          value: 0
        });
      } else {
        this.querySelector('[data-vsub-errors]').hidden = false;
        this.querySelector('input[type="email"]').setAttribute('aria-invalid', 'true');
      }
      this.open();
      if (location.hash === `#${this.form.id}`) {
        const cleanUrl = new URL(location.href);
        cleanUrl.hash = '';
        cleanUrl.searchParams.delete('customer_posted');
        history.replaceState(history.state, '', cleanUrl);
      }
    }
  });
}
